module.exports = __webpack_public_path__ + "static/media/logo_solid-verified-files.4e22ccae.svg";